import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

const useFormButtons = () => {
  const navigate = useNavigate()
  const onBack = useCallback(() => {
    navigate(-1)
  }, [navigate])
  return { onBack }
}

export default useFormButtons
